
import React from 'react'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

interface EditingControlsProps {
  onSave: () => void
  onCancel: () => void
  className?: string
}

export function EditingControls({
  onSave,
  onCancel,
  className = '',
}: EditingControlsProps) {
  return (
    <div className={`mt-1 flex justify-start gap-1 ${className}`}>
      <Button size="sm" className="h-5 w-5 p-0" onClick={onSave}>
        <Icon name="check" className="h-3 w-3" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className="h-5 w-5 p-0"
        onClick={onCancel}
      >
        <Icon name="x" className="h-3 w-3" />
      </Button>
    </div>
  )
}
